var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 81,
    viewBox: "0 0 82 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.21222 64.3597L10.1505 48.8223L17.4719 33.2339H25.39L32.1684 17.3848L39.9134 33.2339V49.1839L39.938 49.1389L48.7304 33.2315H56.6353L63.9567 48.8197C66.9621 48.8197 68.6471 48.8197 71.6525 48.8197L79.4361 64.5497",
    fill: "#93B5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21222 64.3597L10.1505 48.8223L17.4719 33.2339H25.39L32.1684 17.3848L39.9134 33.2339V49.1839L39.938 49.1389L48.7304 33.2315H56.6353L63.9567 48.8197H71.6525L75.5443 56.6847L79.4361 64.5497",
    stroke: "#2F68E5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.46231 65.9991C3.34488 65.9991 4.06035 65.3364 4.06035 64.5191C4.06035 63.7017 3.34488 63.0391 2.46231 63.0391C1.57973 63.0391 0.864258 63.7017 0.864258 64.5191C0.864258 65.3364 1.57973 65.9991 2.46231 65.9991Z",
    fill: "#EBF1FF",
    stroke: "#2F68E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92074 50.5391C10.8033 50.5391 11.5188 49.8765 11.5188 49.0591C11.5188 48.2417 10.8033 47.5791 9.92074 47.5791C9.03816 47.5791 8.32269 48.2417 8.32269 49.0591C8.32269 49.8765 9.03816 50.5391 9.92074 50.5391Z",
    fill: "#EBF1FF",
    stroke: "#2F68E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3811 34.4209C18.2636 34.4209 18.9791 33.7583 18.9791 32.9409C18.9791 32.1236 18.2636 31.4609 17.3811 31.4609C16.4985 31.4609 15.783 32.1236 15.783 32.9409C15.783 33.7583 16.4985 34.4209 17.3811 34.4209Z",
    fill: "#EBF1FF",
    stroke: "#2F68E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8396 34.4209C25.7222 34.4209 26.4377 33.7583 26.4377 32.9409C26.4377 32.1236 25.7222 31.4609 24.8396 31.4609C23.957 31.4609 23.2416 32.1236 23.2416 32.9409C23.2416 33.7583 23.957 34.4209 24.8396 34.4209Z",
    fill: "#EBF1FF",
    stroke: "#2F68E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2981 17.96C33.1807 17.96 33.8962 17.2974 33.8962 16.48C33.8962 15.6626 33.1807 15 32.2981 15C31.4155 15 30.7001 15.6626 30.7001 16.48C30.7001 17.2974 31.4155 17.96 32.2981 17.96Z",
    fill: "#EBF1FF",
    stroke: "#2F68E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8216 34.4209C40.7042 34.4209 41.4197 33.7583 41.4197 32.9409C41.4197 32.1236 40.7042 31.4609 39.8216 31.4609C38.939 31.4609 38.2236 32.1236 38.2236 32.9409C38.2236 33.7583 38.939 34.4209 39.8216 34.4209Z",
    fill: "#EBF1FF",
    stroke: "#2F68E5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4666 50.5391C40.3492 50.5391 41.0647 49.8765 41.0647 49.0591C41.0647 48.2417 40.3492 47.5791 39.4666 47.5791C38.5841 47.5791 37.8686 48.2417 37.8686 49.0591C37.8686 49.8765 38.5841 50.5391 39.4666 50.5391Z",
    fill: "#EBF1FF",
    stroke: "#2F68E5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9919 34.4209C49.8745 34.4209 50.59 33.7583 50.59 32.9409C50.59 32.1236 49.8745 31.4609 48.9919 31.4609C48.1093 31.4609 47.3939 32.1236 47.3939 32.9409C47.3939 33.7583 48.1093 34.4209 48.9919 34.4209Z",
    fill: "#EBF1FF",
    stroke: "#2F68E5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8054 34.4209C57.688 34.4209 58.4034 33.7583 58.4034 32.9409C58.4034 32.1236 57.688 31.4609 56.8054 31.4609C55.9228 31.4609 55.2073 32.1236 55.2073 32.9409C55.2073 33.7583 55.9228 34.4209 56.8054 34.4209Z",
    fill: "#EBF1FF",
    stroke: "#2F68E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6189 50.5391C65.5015 50.5391 66.217 49.8765 66.217 49.0591C66.217 48.2417 65.5015 47.5791 64.6189 47.5791C63.7363 47.5791 63.0209 48.2417 63.0209 49.0591C63.0209 49.8765 63.7363 50.5391 64.6189 50.5391Z",
    fill: "#EBF1FF",
    stroke: "#2F68E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3675 50.5391C72.25 50.5391 72.9655 49.8765 72.9655 49.0591C72.9655 48.2417 72.25 47.5791 71.3675 47.5791C70.4849 47.5791 69.7694 48.2417 69.7694 49.0591C69.7694 49.8765 70.4849 50.5391 71.3675 50.5391Z",
    fill: "#EBF1FF",
    stroke: "#2F68E5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5377 65.9991C80.4203 65.9991 81.1357 65.3364 81.1357 64.5191C81.1357 63.7017 80.4203 63.0391 79.5377 63.0391C78.6551 63.0391 77.9396 63.7017 77.9396 64.5191C77.9396 65.3364 78.6551 65.9991 79.5377 65.9991Z",
    fill: "#EBF1FF",
    stroke: "#2F68E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.968c0f937586612619a7da1198f9fc7f.svg";
export { ForwardRef as ReactComponent };